import React from 'react';
import QRCode from 'react-qr-code';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { clientProfileRoutes, paymentRoutes, staticRoutes } from '@atlas/routing';

import TerminalQrCodePopup from 'src/terminal/popups/TerminalQrCodePopup';

import { NotAuthorizedRedirect } from '../components/NotAuthorizedRedirect';

const TerminalWithdrawalPopup = ({ id }) => {
  const { pathname } = useLocation();
  const history = useHistory();
  const link = `${window.MobileMainLink}${staticRoutes.clientProfile}/${clientProfileRoutes.payment}/${paymentRoutes.withdrawal}`;

  const closePopup = () => {
    history.push(pathname);
  };

  return (
    <>
      <NotAuthorizedRedirect to={pathname} />
      <TerminalQrCodePopup
        className="terminal-withdrawal-modal"
        customHandleClose={closePopup}
        id={id}
        qrCode={<QRCode size={240} value={link} />}
        text="terminal_withdrawal_popup_text"
        title="terminal_withdrawal_popup_title"
      />
    </>
  );
};

TerminalWithdrawalPopup.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TerminalWithdrawalPopup;
